export default __webpack_public_path__ + "static/pragicts-ai-quality-ba9a9454382d492483a35711883b9959.jpg";